<script>
import { mapGetters } from 'vuex';
import router from '../../../../index';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';

import Spinner from 'shared/components/Spinner.vue';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';

export default {
  components: {
    Spinner,
    PageHeader,
    AgentSelector,
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedAgents: [],
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
      uiFlags: 'issueMembers/getUIFlags',
    }),

    issueId() {
      return this.$route.params.issueId;
    },
    headerTitle() {
      return this.$t('ISSUES_SETTINGS.EDIT_FLOW.AGENTS.TITLE', {
        issueName: this.currentIssue.name,
      });
    },
    currentIssue() {
      return this.$store.getters['issues/getIssue'](this.issueId);
    },
    issueMembers() {
      return this.$store.getters['issueMembers/getIssueMembers'](this.issueId);
    },
    showAgentsList() {
      const { id } = this.currentIssue;
      return id && !this.uiFlags.isFetching;
    },
  },

  async mounted() {
    const { issueId } = this.$route.params;
    this.$store.dispatch('agents/get');
    try {
      await this.$store.dispatch('issueMembers/get', {
        issueId,
      });
      const members = this.issueMembers.map(item => item.id);
      this.updateSelectedAgents(members);
    } catch {
      this.updateSelectedAgents([]);
    }
  },

  methods: {
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
    },
    async addAgents() {
      this.isCreating = true;
      const { issueId, selectedAgents } = this;

      try {
        await this.$store.dispatch('issueMembers/update', {
          issueId,
          agentsList: selectedAgents,
        });
        router.replace({
          name: 'settings_issues_edit_finish',
          params: {
            page: 'edit',
            issueId,
          },
        });
        this.$store.dispatch('issues/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6">
    <form
      class="flex flex-wrap mx-0 overflow-x-auto"
      @submit.prevent="addAgents"
    >
      <div class="w-full">
        <PageHeader
          :header-title="headerTitle"
          :header-content="$t('ISSUES_SETTINGS.EDIT_FLOW.AGENTS.DESC')"
        />
      </div>

      <div class="w-full">
        <div v-if="v$.selectedAgents.$error">
          <p class="error-message pb-2">
            {{ $t('ISSUES_SETTINGS.ADD.AGENT_VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          v-if="showAgentsList"
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :is-working="isCreating"
          :submit-button-text="
            $t('ISSUES_SETTINGS.EDIT_FLOW.AGENTS.BUTTON_TEXT')
          "
        />
        <Spinner v-else />
      </div>
    </form>
  </div>
</template>
